import type { ReactNode } from 'react';
import { FormattedNumber } from 'react-intl';

import { Card, Typography } from 'antd';

import PermissionHide from 'v2/components/Shared/PermissionHide';
import { isEntryBalanceOffer } from 'v2/helpers/highTicket';

type HighTicketSummaryProps = {
  product: any;
};

const Money = ({ value }: { value: number }) => (
  <>
    <PermissionHide inverse action='myeduzz:meus-produtos:ocultar-valores'>
      <FormattedNumber value={value || 0} format='BRL' />
    </PermissionHide>
    <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
      <em className='font-normal not-italic'>oculto</em>
    </PermissionHide>
  </>
);

const Metric = ({ label, value, success }: { label: string; value: ReactNode; success?: boolean }) => (
  <div className='flex w-full justify-between'>
    <Typography.Text type='secondary'>{label}</Typography.Text>
    <Typography.Text strong type={success ? 'success' : undefined}>
      {value}
    </Typography.Text>
  </div>
);

const HighTicketSummary = ({ product }: HighTicketSummaryProps) => {
  const isEntryBalance = isEntryBalanceOffer(product);

  return (
    <Card size='small'>
      <div className='flex flex-col flex-wrap items-start gap-y-3'>
        <Metric label='Ganhos' success value={<Money value={product.total_gains} />} />

        {isEntryBalance && (
            <Metric
              label={`Entrada (${product.entry_percentage ?? 0}%)`}
              value={<Money value={product.entry_value} />}
            />
          )}

          {isEntryBalance && (
            <Metric
              label={`Saldo restante (${product.remaining_percentage ?? 0}%)`}
              value={<Money value={product.remaining_value} />}
            />
          )}

        <Metric label='Valor total' value={<Money value={product.total_value} />} />
      </div>
    </Card>
  );
};

export default HighTicketSummary;
